module.exports = __webpack_public_path__ + "static/media/rollers1.e48ffdce.webp";